<script>
    import TablaBolsasTermicas from "./BolsasTermicasTabla.svelte";
    var bolsa = false;
    function mostrarDiv(id){
            bolsa = !bolsa;
    }
</script>
<div class="row">
    <div class="col-2 col-lg-7 linea">
    </div>
    <div class="col-10 col-lg-5">
        <h2>Bolsas Térmicas</h2>
    </div>
</div>
<div class="row">
    <div class="col-12 col-lg-4 text-center">
        <img class="card-img-top" src="img/Low/Bolsatermicas.png" width="75%" alt="Bolsas termicas ICEMAGELES">
    </div>
    <div class="col-12 col-lg-8">
            <ul>
                <li>
                    Ayuda a mantener la temperatura de los elementos en su interior
                </li>
                <li>
                    Es la solución ideal para mantener la integridad de varios productos sensibles a la temperatura
                </li>
                <li>
                   Es ideal para productos Farmacéuticos como, sueros, insulina, vacunas o muestras que requieran el mantenimiento correspondiente del rango de temperatura de +2° a +8°C en tránsitos cortos
                </li>
            </ul>
    </div>
    <div class="col-12" style="text-align:center;">
        <button class="boton-info" on:click={() => mostrarDiv("bolsa")}>+Info</button>
    </div>
</div>
{#if bolsa}
  <TablaBolsasTermicas />
{/if}